import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tela-noticias',
  templateUrl: './tela-noticias.component.html',
  styleUrls: ['./tela-noticias.component.scss']
})
export class TelaNoticiasComponent implements OnInit {

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-noticias/tela-noticias.component.ts